export default {
    baseStyle: (props) => ({
        cartPageRoot: {
            flex: '1'
        },
        cartPageContainer: {
            px: {base: 4, lg: 6},
            paddingTop: {base: 8, lg: 8},
            paddingBottom: {base: 0}
        },
        cartMainStack: {
            spacing: 24
        },
        cartContentStack: {
            spacing: 8
        },
        cartBannerStack: {
            spacing: 4,
            mb: 8,
            w: '100%'
        },
        cartGrid: {
            templateColumns: {base: '1fr', lg: '58.12% 1fr'},
            gap: {base: 10, lg: 60},
            width: 'full'
        },
        cartMainGridItem: {
            maxW: 'full',
            minWidth: 0
        },
        cartProductListStack: {
            spacing: 8,
        },
        cartSideGridItem: {
            maxW: 'full'
        },
        cartSideGridItemInner: {
            position: {base: 'static', lg: 'sticky'},
            top: {base: '0', lg: '80px'},
            alignSelf: 'flex-start'
        },
        cartSideStack: {
            spacing: 8
        },
        cartCarouselLoadingWrapper: {
            display: 'flex',
            gap: 4,
            overflow: 'hidden',
            width: '100%'
        },
        cartCarouselLoadingCard: {
            width: 'calc(20% - 16px)',
            flexShrink: 0
        },
        cartCarouselLoadingCardStack: {
            spacing: 4
        },
        cartCarouselStack: {
            spacing: 8
        },
        cartCtaButton: {
            width: 'full'
        },
        cartNoReturnWrapper: {
            mb: '8'
        },
        cartNoReturnText: {
            textStyle: 'bodyXsRegular'
        },
        cartTitleHeading: {
            as: 'h1',
            textStyle: 'webH1',
            mb: '6'
        },
        cartProgressText: {
            mb: '4'
        },
        cartSecondaryActionButton: {
            textStyle: 'bodyXsLink'
        },
        cartSecondaryRemoveButton: {
            textStyle: 'bodyXsLink'
        },
        cartItemBrandText: {
            textStyle: 'bodyXsRegular',
            color: 'webTypo.textTertiary',
            textTransform: props?.brand === 'garage' ? 'uppercase' : 'capitalize'
        },
        cartItemNameText: {
            textStyle: 'labelXs',
            display: 'block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            width: '100%',
            mb: 1
        },
        cartItemNameLink: {
            display: 'block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        cartSkeletonRoot: {
            background: 'webBasic.50',
            flex: '1',
            paddingBottom: {base: 20, lg: 55}
        },
        cartSkeletonContainer: {
            background: 'webBasic.50',
            maxWidth: 'container.xl',
            p: [4, 6, 6, 4],
            paddingTop: [null, null, null, 6]
        },
        cartSkeletonGrid: {
            templateColumns: {base: '1fr', lg: '58.12% 1fr'},
            gap: {base: 10, lg: 60}
        },
        cartSkeletonMainStack: {
            paddingTop: 4,
            spacing: 4
        },
        cartSkeletonTitleText: {
            fontWeight: 'bold',
            fontSize: ['xl', 'xl', 'xl', '2xl']
        },
        cartSkeletonItemCard: {
            spacing: 4,
            layerStyle: 'card',
            boxShadow: 'none'
        },
        cartSkeletonItemRow: {
            width: 'full',
            bg: 'white',
            marginBottom: [4, 3]
        },
        cartSkeletonItemImage: {
            width: {base: '140px', lg: '225px'},
            mr: {base: 3, lg: 4},
            height: '180px',
            flexShrink: 0
        },
        cartSkeletonItemMetaStack: {
            marginLeft: [4, 6],
            spacing: 2,
            flex: 1
        },
        cartSkeletonSidebar: {
            py: 7
        },
        cartSkeletonSidebarStack: {
            paddingTop: {base: 0, lg: 8},
            spacing: 3,
            px: [6, 6, 6, 0]
        },
        cartSkeletonSummaryHeading: {
            pt: 1
        },
        cartSkeletonSummaryList: {
            spacing: 3,
            align: 'flex-start'
        },
        emptyCartRoot: {
            flex: '1'
        },
        emptyCartContainer: {
            overflowX: {base: 'auto', lg: 'hidden'},
            maxWidth: 'container.xxl',
            paddingTop: {base: 8, lg: 8},
            paddingBottom: {base: 8, lg: 14}
        },
        stickyBarRoot: {
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            bg: 'white',
            borderTop: '1px solid',
            borderColor: 'webTheme.backgroundPrimaryBrand',
            boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.1)',
            zIndex: 1000,
            transition: 'transform 0.3s ease-in-out'
        },
        stickyBarContainer: {
            maxWidth: '1440px',
            px: {base: 4, lg: '24px'},
            pr: {base: 4, lg: '141px'}
        },
        stickyBarMobileStack: {
            spacing: 3,
            pb: 4,
            pt: 3
        },
        stickyBarRow: {
            justify: 'space-between',
            align: 'center'
        },
        stickyBarLabel: {
            textStyle: 'bodyXsBold',
            textTransform: 'uppercase'
        },
        stickyBarAmount: {
            textStyle: 'bodyXsBold'
        },
        stickyBarMobileButton: {
            width: 'full'
        },
        stickyBarDesktopRow: {
            justify: 'space-between',
            align: 'center',
            gap: 6,
            py: 4
        },
        stickyBarDesktopTotal: {
            align: 'baseline',
            gap: 3
        },
        stickyBarDesktopButton: {
            width: '352px'
        }
    })
}
